class Uploader {
    handleFileSelect(e) {
        let list = e.parentNode.getElementsByClassName("custom-file-list")[0];
        let label = e.parentNode.getElementsByClassName("custom-file-label")[0];
        list.innerHTML = "";
        let files = e.files;
        for (let f of files) {
            if (typeof f.type === "string") {
                if (f.type.match(/^image\/.*/)) {
                    label.innerHTML = f.name;
                    let reader = new FileReader();
                    reader.onload = function (e) {
                        list.innerHTML += '<img src="' + e.target.result + '">';
                    }.bind(list);
                    reader.readAsDataURL(f);
                } else {
                    list.innerHTML += f.name + "<br>";
                }
                list.style.display = "block";
            }
        }
    }

    handleMediaSelect(t) {
        let ne = t.nextElementSibling;
        let n = t.getAttribute("name");
        t.setAttribute("name", n.replace("_no_file", ""));
        if (ne && ne.hasAttribute("name")) {
            ne.remove();
        }
        this.handleFileSelect(t);
    }
}
